import React from "react";

export const CustomerFeedback = () => {
    return <div>Company Feedback</div>;
};
